import React, { useState } from 'react';
import { withStyles } from 'theme/withStyles';
import { connect } from 'react-redux';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Collapse } from 'react-collapse';
import Field from 'containers/Field';
import Checkmark from './components/Checkmark';
import Subtext from './components/Subtext';
import Content from './components/Content';
import DetailHandle from './components/DetailHandle';
import DisplayRateAmount from './components/DisplayRateAmount';
import commonStyles from './styles';
import Label from './components/Label';

const styles = (theme) => {
  const common = {
    ...commonStyles(theme),
  };
  return {
    ...common,

    rateAmount: {
      textAlign: 'left',
    },
    statsReadOnly: {
      [`@media(min-width: ${theme.screenSizes.mobileMax}px)`]: {
        '& > div': {
          width: '100%',
        },
        justifyContent: 'center',
      },
      '& > div': {
        textAlign: 'center',
      },
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: 10,
    },
    value: {
      ...common.value,
      '& span': {
        fontSize: 18,
        lineHeight: '36px',
        verticalAlign: 'top',
      },
    },
  };
};

export const OeLoanBare = ({
  classes,
  fieldAPRValue,
  fieldAmount,
  fieldAmountIsReadOnly,
  fieldAmountValue,
  fieldChosen,
  isInAllBundle,
  labelAPR,
  labelAmount,
  name,
  offerLabelText,
  rates,
  showOffersDetails,
  subText,
}) => {
  const [collapsed, setCollapse] = useState(!showOffersDetails);
  const hasAprValue = fieldAPRValue !== undefined && fieldAPRValue !== null;
  const hasAmountValue = fieldAmount !== undefined && fieldAmount !== null;

  return (
    <>
      {!isInAllBundle ? <Checkmark name={name} /> : <Label label={offerLabelText} />}
      <DetailHandle setCollapse={setCollapse} collapsed={collapsed} />
      <Collapse isOpened={!collapsed}>
        <div className="content">
          <Content fieldChosen={fieldChosen} collapsed={collapsed}>
            <Subtext>{subText}</Subtext>
            {rates && <Field fieldName={rates} groupName={name} />}
            <div
              className={classnames(
                'stats',
                fieldAmountIsReadOnly ? classes.statsReadOnly : classes.stats,
              )}
            >
              {hasAprValue ? (
                <DisplayRateAmount
                  label={labelAPR}
                  value={fieldAmountIsReadOnly ? fieldAPRValue : `${fieldAPRValue}%`}
                  isPercentage={fieldAmountIsReadOnly}
                  className={classnames({ [classes.rateAmount]: !fieldAmountIsReadOnly })}
                />
              ) : null}
              {fieldAmountIsReadOnly && hasAmountValue ? (
                <DisplayRateAmount
                  label={labelAmount}
                  value={fieldAmountValue}
                  className="amount"
                />
              ) : (
                <div className={classnames('region-field-amount', classes.amount)}>
                  <Field fieldName={fieldAmount} groupName={`${name}_OFFER`} />
                </div>
              )}
            </div>
          </Content>
        </div>
      </Collapse>
    </>
  );
};

OeLoanBare.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  fieldAPRValue: PropTypes.number,
  fieldAmount: PropTypes.string.isRequired,
  fieldAmountIsReadOnly: PropTypes.bool,
  fieldAmountValue: PropTypes.string.isRequired,
  fieldChosen: PropTypes.string.isRequired,
  isInAllBundle: PropTypes.bool,
  labelAPR: PropTypes.string.isRequired,
  labelAmount: PropTypes.string,
  name: PropTypes.string.isRequired,
  offerLabelText: PropTypes.string,
  rates: PropTypes.string,
  showOffersDetails: PropTypes.bool.isRequired,
  subText: PropTypes.string,
};

OeLoanBare.defaultProps = {
  fieldAPRValue: null,
  fieldAmountIsReadOnly: undefined,
  isInAllBundle: false,
  labelAmount: undefined,
  offerLabelText: '',
  rates: '',
  subText: '',
};

const OeLoanBase = withStyles(styles)(OeLoanBare);

const mapDispatchToProps = ({ configs, data, fields, offers }, { name }) => {
  const offer = offers[name];

  return {
    fieldAPRValue: data[offer.fieldAPR],
    fieldAmount: offer.fieldAmount,
    fieldAmountIsReadOnly: fields[offer.fieldAmount]?.readOnly,
    fieldAmountValue: (typeof data[offer.fieldAmount] === 'string'
      ? parseFloat(data[offer.fieldAmount])
      : data[offer.fieldAmount] || 0
    ).toLocaleString('en-US', {
      currency: 'USD',
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
      style: 'currency',
    }),
    fieldChosen: offer.fieldChosen,
    labelAPR: offer.labelAPR,
    labelAmount: fields[offer.fieldAmount]?.label,
    offerLabelText: offer.label,
    rates: offer.rates,
    showOffersDetails: configs.showOffersDetails,
    subText: offer.subText,
  };
};

export default connect(mapDispatchToProps)(OeLoanBase);
